import { render, staticRenderFns } from "./TotalPageCount.vue?vue&type=template&id=273986b0&scoped=true&"
import script from "./TotalPageCount.vue?vue&type=script&lang=js&"
export * from "./TotalPageCount.vue?vue&type=script&lang=js&"
import style0 from "./TotalPageCount.vue?vue&type=style&index=0&id=273986b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273986b0",
  null
  
)

export default component.exports